import { theme } from 'styled-tools';
import styled from 'styled-components/macro';

const PageWrapper = styled.div`
  background-color: ${theme('colors.backgroundGray')};
  height: 100%;
  padding-top: 5rem;
`;

export default PageWrapper;
